var _circle, _rect, _rect2, _ellipse, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatCreative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#fff5e6",
    stroke: "#ffd0a0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 6,
    height: 28,
    rx: 3,
    fill: "#c8956a",
    stroke: "#8a5530",
    strokeWidth: 1.5,
    transform: "rotate(30 49 30)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 36,
    width: 6,
    height: 5,
    rx: 1,
    fill: "#aaa",
    stroke: "#888",
    strokeWidth: 1,
    transform: "rotate(30 46 38.5)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37,
    cy: 50,
    rx: 5,
    ry: 8,
    fill: "#e84040",
    stroke: "#b02020",
    strokeWidth: 1,
    transform: "rotate(30 37 50)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 34,
    r: 5,
    fill: "#4a90d9",
    opacity: 0.85
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 46,
    r: 3.5,
    fill: "#f9d64f",
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 56,
    r: 4,
    fill: "#60c060",
    opacity: 0.85
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 4.5,
    fill: "#9060d0",
    opacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 40,
    r: 3,
    fill: "#f9d64f",
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 22 L56 25 L59 25 L56.5 27 L57.5 30 L55 28 L52.5 30 L53.5 27 L51 25 L54 25Z",
    fill: "#f9d64f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatCreative);
export default __webpack_public_path__ + "static/media/cat-creative.bac3bbfe9e6abfbaf67254fd8db06101.svg";
export { ForwardRef as ReactComponent };